import variables from '../../assets/styles/variables.scss';

export const commonPaletteConfig = {
  primary: {
    main: variables.PrimaryNaviBlue,
    light: variables.PrimaryTint,
  },
  secondary: {
    main: variables.SecondarySkyBlue,
    light: variables.SecondaryTint,
  },
  success: {
    main: variables.SuccessGreenMain,
    light: variables.SuccessGreenAdditional,
  },
  info: {
    main: variables.InfoPurpleMain,
    light: variables.InfoPurpleAdditional,
  },
  warning: {
    main: variables.WarningOrangeMain,
    light: variables.WarningOrangeAdditional,
  },
  error: {
    main: variables.ErrorRedMain,
    light: variables.ErrorRedAdditional,
  },
  grey: {
    50: variables.Grey1,
    100: variables.Grey2,
    200: variables.Grey3,
    300: variables.Grey4,
    500: variables.Grey5,
    600: variables.Grey6,
    700: variables.Grey7,
    900: variables.Grey8,
  },
  background: {
    default: variables.Grey1,
    paper: variables.Grey1,
  },
  text: {
    primary: variables.Grey8,
    secondary: variables.Grey6,
  },
  divider: variables.Grey4,
};

export const commonTypographyConfig = {
  fontFamily: variables.fontStackMedium,
  h1: { fontWeight: 300, fontFamily: variables.fontStackDemi },
  h2: {
    fontWeight: 450,
    fontFamily: variables.fontStackDemi,
  },
  h3: { fontWeight: 450, fontFamily: variables.fontStackDemi },
  body1: { fontWeight: 300, fontFamily: variables.fontStackBook },
  body2: { fontWeight: 300, fontFamily: variables.fontStackBook },
};

// Component overrides - Checkbox, Radio, Form, Pagination
export const commonComponentsConfig = (palette: any) => ({
  MuiCheckbox: {
    defaultProps: {
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        color: palette.secondary.main,
        '&.Mui-checked': {
          color: palette.secondary.main,
        },
        '&:hover': {
          backgroundColor: 'transparent',
          color: palette.secondary.light,
        },
        '&.Mui-disabled': {
          color: palette.grey[300],
        },
      },
    },
  },

  MuiRadio: {
    defaultProps: {
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        color: palette.secondary.main,
        '&.Mui-checked': {
          color: palette.secondary.main,
        },
        '&:hover': {
          backgroundColor: 'transparent',
          color: palette.secondary.light,
        },
        '&.Mui-disabled': {
          color: palette.grey[300],
        },
      },
    },
  },

  MuiFormGroup: {
    styleOverrides: {
      root: {},
    },
  },

  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        '& .MuiFormControlLabel-label': {
          fontFamily: variables.fontStackMedium,
          fontSize: '16px',
          color: palette.text.primary,
          userSelect: 'none',
        },
        '&:hover .MuiFormControlLabel-label': {
          color: palette.secondary.main,
        },
        '&.Mui-disabled .MuiFormControlLabel-label': {
          color: palette.grey[300],
        },
      },
    },
  },

  MuiPagination: {
    styleOverrides: {
      root: {
        display: 'flex',
        justifyContent: 'flex-end',
      },
    },
  },

  MuiPaginationItem: {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          backgroundColor: 'transparent',
          outline: `1px solid ${palette.divider}`,
        },
      },
    },
  },

  MuiButtonBase: {
    defaultProps: {
      TouchRippleProps: {
        classes: {
          ripple: 'custom-ripple',
        },
      },
    },
    styleOverrides: {
      root: {
        '& .custom-ripple': {
          width: '50% !important',
          height: '50% !important',
        },
        '& .custom-ripple::after': {
          borderRadius: '50%',
          content: '""',
          display: 'block',
          paddingTop: '100%',
        },
      },
    },
  },
});
